import { useMemo, ReactNode } from 'react';
import { CssBaseline } from '@mui/material';
import {
  createTheme,
  ThemeOptions,
  ThemeProvider as MUIThemeProvider,
  StyledEngineProvider,
  Direction,
} from '@mui/material/styles';

import palette from './palette';
import typography from './typography';
import breakpoints from './breakpoints';
import componentsOverride from './overrides';
import shadows, { customShadows } from './shadows';
import { defaultSettings } from 'src/config';

//
//
//
//

type Props = {
  children: ReactNode;
};

export default function ThemeProvider({ children }: Props) {
  const isLight = defaultSettings.themeMode === 'light';

  const themeOptions: ThemeOptions = useMemo(
    () => ({
      palette: palette.light,
      typography: {
        ...typography,
      },
      fontFamily: {
        primary: 'ObjektivMk1, Outfit, Trebuchet MS, sans-serif',
        secondary: 'Mirador, Newsreader, Georgia, serif',
      },
      breakpoints,
      shape: { borderRadius: 0 },
      direction: defaultSettings.themeDirection as Direction,
      shadows: isLight ? shadows.light : shadows.dark,
      customShadows: isLight ? customShadows.light : customShadows.dark,
    }),
    [isLight]
  );

  const theme = createTheme(themeOptions);

  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
